export class ArbetsorderVolym implements IArbetsorderVolym {
    tallTimmer: number;
    granTimmer: number;
    klentimmerTall: number;
    klentimmerGran: number;
    barrmassaved: number;
    lovmassaved: number;
    volymArbetsorder: number;
    totalVolym: number;

    constructor() {
        this.tallTimmer = 0;
        this.granTimmer = 0;
        this.klentimmerTall = 0;
        this.klentimmerGran = 0;
        this.barrmassaved = 0;
        this.lovmassaved = 0;
        this.volymArbetsorder = 0;
        this.totalVolym = 0;
    }
}

export interface IArbetsorderVolym {
    tallTimmer: number;
    granTimmer: number;
    klentimmerTall: number;
    klentimmerGran: number;
    barrmassaved: number;
    lovmassaved: number;
    volymArbetsorder: number;
    totalVolym: number;
}
